var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPesaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.95,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 34.9985C28.2843 34.9985 35 28.2828 35 19.9985C35 11.7143 28.2843 4.99854 20 4.99854C11.7157 4.99854 5 11.7143 5 19.9985C5 24.3462 6.84968 28.2618 9.80504 31.0015L13.1113 11.974L21.8271 11.9911C24.516 11.9911 26.6294 12.7373 28.1675 14.2298C29.7056 15.7223 30.3778 17.6706 30.1841 20.0745C30.0018 22.5127 28.9821 24.4609 27.125 25.9193C25.2793 27.3776 22.9209 28.1068 20.0498 28.1068L15.333 28.0897L14.3164 33.8843C16.0693 34.6026 17.9884 34.9985 20 34.9985ZM20.2036 23.971L16.0337 23.9369L17.4009 16.1268L22.1177 16.1439C23.2 16.1895 24.0146 16.5654 24.5615 17.2718C25.1198 17.9782 25.3135 18.9238 25.1426 20.1087C24.9717 21.2936 24.4419 22.2336 23.5532 22.9286C22.6646 23.6235 21.548 23.971 20.2036 23.971Z",
    fill: "#1DB100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesaIcon);
export default __webpack_public_path__ + "static/media/PesaIcon.0b47357a7b49c457cd7b94ed3205ed66.svg";
export { ForwardRef as ReactComponent };